<div (click)="click.emit()">
    <ng-content></ng-content>
</div>
